<template>
    <div class="battery_container">
        <div class="dataline">
            <div class="datacontainer">
                <div class="data_title">剩余电量</div>
                <div class="data_value">116kWh</div>
            </div>
            <div class="datacontainer">
                <div class="data_title">电池容量</div>
                <div class="data_value">200kWh</div>
            </div>
            <div class="datacontainer">
                <div class="data_title">电池状态</div>
                <div class="data_value" style="color: #68D86A">正常</div>
            </div>
        </div>
        <div class="imageline">
            <div class="big">
                <div v-for="index in 21" :key="index" class="big_white_line"></div>
                <div class="big_blue" :style="'width:' + (Math.floor(116/10)*10)/200*9300/192 + 'vw'"></div>
                <div class="big_white"></div>
            </div>
            <div class="small"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Battery"
    }
</script>

<style lang="less" scoped>
    .battery_container {
        width: 100%;
        height: 100%;
        padding-left: 8rem;

        .dataline {
            width: 100%;
            height: 40%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;

            .datacontainer {
                width: 33%;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: space-evenly;

                .data_title {
                    font-size: 18rem;
                    color: #666666;
                }

                .data_value {
                    font-size: 24rem;
                    font-weight: bold;
                    color: #0D94FF;
                }
            }
        }

        .imageline {
            width: 100%;
            height: 50%;
            display: flex;
            flex-direction: row;
            align-items: center;

            .big {
                .w(936);
                .h(108);
                border: 10/192vw solid #ccc;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                background: #fff;
                z-index: 3;
                position: relative;

                .big_blue {
                    min-width: 0;
                    .h(100);
                    position: absolute;
                    left: 0;
                    background: #B0E6FF;
                }
            }

            .small {
                .w(16);
                .h(48);
                border: 10/192vw solid #ccc;
                margin-left: -10/192vw;
            }
        }
    }

    .big_white_line {
        .w(2);
        .h(104);
        background: #fff;
        z-index: 2;
    }

    .big_white {
        .w(934);
        .h(104);
        position: absolute;
        right: 0;
        background: #fff;
        animation: leave 2s;
        animation-fill-mode: forwards;
    }

    @keyframes leave {
        0% {
            width: 9340/192vw;
        }

        100% {
            width: 0;
        }
    }
</style>